/**
 * The local player's live input, written by the controls and read by the
 * renderer for movement prediction and the shot charge meter.
 */
export const localInput = {
  moveX: 0,
  /** performance.now() when the shot key went down; 0 while released. */
  shootHeldSince: 0,
};
